var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.667,
    height: 20,
    viewBox: "0 0 16.667 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.833,5h-.908l-1.5,13.432A1.786,1.786,0,0,1,11.667,20H5a1.783,1.783,0,0,1-1.753-1.57L1.767,5H.833a.833.833,0,0,1,0-1.667H5V2.5A2.5,2.5,0,0,1,7.5,0H9.167a2.5,2.5,0,0,1,2.5,2.5v.833h4.167a.833.833,0,0,1,0,1.667ZM10,2.5a.834.834,0,0,0-.833-.833H7.5a.834.834,0,0,0-.833.833v.833H10ZM3.443,5,4.9,18.247a.134.134,0,0,0,.1.087h6.667a.135.135,0,0,0,.1-.088L13.248,5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashWhite);
export default __webpack_public_path__ + "static/media/trash-white.eabf7fd98db8ee4cbcfc5cdea19dc5b2.svg";
export { ForwardRef as ReactComponent };